import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Drzava, ApiClientService } from '../../services/api-client.service';

@Component({
  selector: 'app-drzave',
  templateUrl: './drzave.component.html',
  styleUrls: ['./drzave.component.scss']
})
export class DrzaveComponent {
  @ViewChild('drzaveGrid', { static: false }) drzaveGrid: any;

  gridData: Drzava[] = [];
  loading = false;
  isEditPopupVisible = false;
  isCreatePopupVisible = false;
  selectedDrzava: Drzava | null = null;
  loadPanelPosition = { of: '#drzaveGrid' };

  drzavaForm!: FormGroup;

  constructor(
    private apiClient: ApiClientService,
    private fb: FormBuilder
  ) {
    this.initializeForm();
  }

  ngOnInit() {
    this.loadDrzave();
  }

  initializeForm() {
    this.drzavaForm = this.fb.group({
      naziv: ['', Validators.required]
    });
  }

  async loadDrzave() {
    this.loading = true;
    try {
      this.gridData = await this.apiClient.drzaveAll();
    } catch (error) {
      console.error('Error loading drzave:', error);
    } finally {
      this.loading = false;
    }
  }

  onDrzavaRowClick(e: any) {
    if (e.data) {
      this.selectedDrzava = e.data;
    }
  }

  onAddClick() {
    this.selectedDrzava = null;
    this.drzavaForm.reset();
    this.isCreatePopupVisible = true;
  }

  onEditClick() {
    if (this.selectedDrzava) {
      this.populateForm(this.selectedDrzava);
      this.isEditPopupVisible = true;
    }
  }

  onDeleteClick() {
    if (this.selectedDrzava && confirm('Da li ste sigurni da želite obrisati ovu državu?')) {
      this.deleteDrzava(this.selectedDrzava.id as number);
    }
  }

  populateForm(drzava: Drzava) {
    this.drzavaForm.patchValue({
      naziv: drzava.naziv
    });
  }

  async createDrzava() {
    if (this.drzavaForm.valid) {
      this.loading = true;
      try {
        const formData = this.drzavaForm.value;
        // Ensure ID is not included when creating
        delete formData.id;
        await this.apiClient.drzavePOST(formData);
        this.isCreatePopupVisible = false;
        this.drzavaForm.reset();
        this.loadDrzave(); // Refresh grid
      } catch (error) {
        console.error('Error creating drzava:', error);
      } finally {
        this.loading = false;
      }
    }
  }

  async updateDrzava() {
    if (this.drzavaForm.valid && this.selectedDrzava) {
      this.loading = true;
      try {
        const formData = this.drzavaForm.value;
        // Include the ID when updating
        formData.id = this.selectedDrzava.id;
        await this.apiClient.drzavePUT(this.selectedDrzava.id as number, formData);
        this.isEditPopupVisible = false;
        this.loadDrzave(); // Refresh grid
      } catch (error) {
        console.error('Error updating drzava:', error);
      } finally {
        this.loading = false;
      }
    }
  }

  async deleteDrzava(id: number) {
    this.loading = true;
    try {
      await this.apiClient.drzaveDELETE(id);
      this.selectedDrzava = null;
      this.loadDrzave(); // Refresh grid
    } catch (error) {
      console.error('Error deleting drzava:', error);
    } finally {
      this.loading = false;
    }
  }

  onRefreshClick() {
    this.loadDrzave();
  }

  onEditPopupHidden() {
    this.isEditPopupVisible = false;
    this.selectedDrzava = null;
  }

  onCreatePopupHidden() {
    this.isCreatePopupVisible = false;
  }
}
